import React, { Suspense, useEffect } from 'react';
import { Router, Redirect } from '@reach/router';
import AuthLayout from './layouts/AuthLayout/AuthLayout';
import EntityLayout from './layouts/EntityLayout/EntityLayout';
import { ConfigureLayout } from './layouts/ConfigureLayout/ConfigureLayout';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './redux/reducers';
import { getUserInfoActions } from './redux/actions';

const ApiTesting = React.lazy(() => import('./pages/ApiTesting'));
const Login = React.lazy(() => import('./pages/Login'));
const NotFound = React.lazy(() => import('./pages/NotFound/404'));
const Fundamentals = React.lazy(() => import('./pages/Documentation/Fundamentals'));
const ReleaseNotes = React.lazy(() => import('./pages/Documentation/ReleaseNotes'));
const ErrorCodes = React.lazy(() => import('./pages/Documentation/ErrorCodes'));
const Reconciliation = React.lazy(() => import('./pages/Documentation/Reconciliation'));
const WebhookImplementationGuide = React.lazy(() =>
  import('./pages/Documentation/WebhookImplementationGuide'),
);
const MerchantOnboardingApiGuide = React.lazy(() =>
  import('./pages/Documentation/MerchantOnboardingApiGuide'),
);

const TymeBankAPITestGuide = React.lazy(() => import('./pages/Documentation/TymeBankAPITestGuide'));

const HomeEntity = React.lazy(() => import('./pages/HomeEntity'));
const ApiHome = React.lazy(() => import('./pages/ApiHome'));
const ApiDoc = React.lazy(() => import('./pages/ApiDoc'));
const OAuth2 = React.lazy(() => import('./pages/OAuth2'));


const App = () => {
    const authUser = useSelector((state: RootState) => state.authUser.data);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log('authUser', authUser);
    authUser && dispatch(getUserInfoActions.request());
  }, [dispatch, authUser]);
  return (
  
      <Suspense fallback={<div />}>
        <Router>

          <>
            <HomeEntity path="/" />
            <Fundamentals path="/documentation/fundamentals" />
            <WebhookImplementationGuide path="/documentation/webhook-implementation-guide" />
            <TymeBankAPITestGuide path="/documentation/tyme-bank-api-test-guide" />
            <ReleaseNotes path="/release-notes" />
            <ErrorCodes path="/documentation/tyme-bank-api-error-codes" />
            <Reconciliation path="/documentation/reconciliation" />
            <MerchantOnboardingApiGuide path="/documentation/merchant-onboarding-api-guide" />
            <ApiTesting path="/api-testing" />
            <ConfigureLayout layout={EntityLayout} path="/">
              <ApiHome path="apis" />
              <ApiDoc path="apis/:group/:api" />
              <NotFound default />
            </ConfigureLayout>
            <Redirect noThrow from="/home" to="/" />
          </>
          <AuthLayout path="/auth">
            <Login path="login" />
            <OAuth2 path="authorize" />
          </AuthLayout>
        </Router>
      </Suspense>
  
  );
};

export default App;
